import styled from 'styled-components';

export const HeaderWrapper = styled.nav`
  position: fixed;
  z-index: 9999;
  /* background-color: white; */
  background-color: ${({ theme }) => theme.colors.bgcolor};
  /* background-color: rgba(255, 255, 255, 0.9); */
  background-color: rgba(245, 244, 239, 0.9);

  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    /* height: 60px;
    margin-left: 10px; */
    /* padding: 0; */
  }

  @media ${({ theme }) => theme.media.mobile} {
    height: 80px;
    padding: 20px 18px 20px 22px;
  }
  @media ${({ theme }) => theme.media.tablet} {
    padding: 0 50px 0 90px;
  }
`;
